import { render, staticRenderFns } from "./RecoverSuccess.vue?vue&type=template&id=b1cb424e&scoped=true"
import script from "./RecoverSuccess.vue?vue&type=script&lang=js"
export * from "./RecoverSuccess.vue?vue&type=script&lang=js"
import style0 from "./RecoverSuccess.vue?vue&type=style&index=0&id=b1cb424e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1cb424e",
  null
  
)

export default component.exports